import {Howl} from 'howler';
import {observable} from "@legendapp/state";

export const DefaultVolume = 1;

export enum Sound {
    Message = 'message',
    YourTime = 'your_time',
    HearingStarted = 'hearing_started'
}

const _ = async (sound: string) => (await import('../assets/sounds/' + sound)).default;

const soundMap = {
    [Sound.Message]: {
        src: _('message.mp3'),
        volume: 1
    },
    [Sound.YourTime]: {
        src: _('your_time.mp3'),
        volume: 1
    },
    [Sound.HearingStarted]: {
        src: _('hearing_started.mp3'),
        volume: 1
    },
}

export const SoundService = new class {
    currentVolume = DefaultVolume;
    $soundEnabled = observable(true);

    constructor() {
        (async () => {
            for (const sound in soundMap) {
                const {src, ...rest} = soundMap[sound];
                this[sound] = new Howl({
                    src: [await src],
                    ...rest,
                });
            }
        })();

        let lcSoundEnabled = localStorage.getItem('soundEnabled');
        if (lcSoundEnabled == null) {
            lcSoundEnabled = 'true';
            localStorage.setItem('soundEnabled', 'true');
        }
        this.$soundEnabled.set(lcSoundEnabled === 'true');
    }

    public play(sound: Sound, ignoreMute: boolean = false) {
        if (!this[sound]) return;

        if (!this.shouldPlay(ignoreMute)) return;

        this[sound]?.volume(this.currentVolume);
        this[sound]?.loop(false);
        this[sound]?.play();
    }

    public loopPlay(sound: Sound, ignoreMute: boolean = false) {
        if (!this[sound]) return;

        if (!this.shouldPlay(ignoreMute)) return;

        this[sound]?.volume(this.currentVolume);
        this[sound]?.loop(true);
        this[sound]?.play();
    }

    public stop(sound: Sound) {
        this[sound]?.stop();
    }

    public setVolume(volume: number) {
        this.currentVolume = volume;
    }

    public toggleMute() {
        this.currentVolume = this.currentVolume === 0 ? DefaultVolume : 0;
    }

    public enableSound() {
        this.$soundEnabled.set(true);
        localStorage.setItem('soundEnabled', 'true');
    }

    public disableSound() {
        this.$soundEnabled.set(false);
        localStorage.setItem('soundEnabled', 'false');
    }

    private shouldPlay(ignoreMute: boolean = false) {
        return ignoreMute || (this.currentVolume !== 0 && this.$soundEnabled.get());
    }
}
